import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiie-consent-expanded-text',
  templateUrl: './fiie-consent-expanded-text.component.html',
  styleUrls: ['./fiie-consent-expanded-text.component.scss'],
})
export class FiieConsentExpandedTextComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
